export default "__VITE_ASSET__BHx91rVj__"